var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.message.exists)?_c('div',{staticClass:"form-notification",class:{ 'is-error': _vm.isError }},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.message.message)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }